<div class="page-container">
    <div class="page-title-block">
        <div class="page-type">Date Picker Page</div>
        <div class="more-info-btn" (click)="openMoreInfo()">More info</div>
    </div>
    <ng-container *ngTemplateOutlet="datePickerPagesFormTemplate"></ng-container>
    <div class="more-info-container" [ngClass]="{ 'open': moreInfoOpened }">
        <div class="close-btn-block">
            <button class="close-btn" (click)="closeMoreInfo()">Close</button>
        </div>
        <div class="title">Date Picker Page</div>
        <img src="../../../../../../../../../../assets/img/ABF_more_info/datePickerPage.jpg" alt="More info">
        <div class="desc">A date picker page allows a user to select a day, month, and year. Date range can also be configured.</div>
        <div class="desc eg">E.G. selecting a birth date</div>
    </div>
</div>

<ng-template #datePickerPagesFormTemplate>
    <div class="page-content">
        <ng-container [formGroup]="datePickerPageForm">
            <div class="fields-block">
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Page Header</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input class="input-field" placeholder="Enter page header" [formControlName]="'pageHeader'" (ngModelChange)="setPageDataHandler()"/>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Page Subheader</label>
                    </div>
                    <input class="input-field" placeholder="Enter subheader" [formControlName]="'pageSubHeader'"/>
                    <input-validators controlName="pageSubHeader" [control]="datePickerPageForm.controls['pageSubHeader']"></input-validators>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Hint Text</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input class="input-field" placeholder="Enter hint text" [formControlName]="'hintText'"/>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Label Text</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input class="input-field" placeholder="Enter label text" [formControlName]="'labelText'"/>
                </div>
                <span class="line"></span>
                <div class="form-field-block full-size">
                    <div class="label-container">
                        <label class="label">Date Format</label>
                    </div>
                    <div class="date-format-block">
                        <label class="label bordered">
                            <input class="checkbox" type="radio" value="yyyy/MM/dd" name="dateFormat" [formControlName]="'dateFormat'" (change)="resetDates()"/>
                            <span class="checkbox-styled"></span>
                            <span class="label-text">YYYY/MM/DD</span>
                        </label>
                        <label class="label bordered">
                            <input class="checkbox" type="radio" value="MM/dd/yyyy" name="dateFormat" [formControlName]="'dateFormat'" (change)="resetDates()"/>
                            <span class="checkbox-styled"></span>
                            <span class="label-text">MM/DD/YYYY</span>
                        </label>
                        <label class="label bordered">
                            <input class="checkbox" type="radio" value="dd/MM/yyyy" name="dateFormat" [formControlName]="'dateFormat'" checked (change)="resetDates()"/>
                            <span class="checkbox-styled"></span>
                            <span class="label-text">DD/MM/YYYY</span>
                        </label>
                    </div>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Start Date</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input type="text" class="input-field suffix"
                           ngxDaterangepickerMd
                           [closeOnAutoApply]="true"
                           [autoApply]="true"
                           [style]="{'display': 'none'}"
                           (datesUpdated)="datesUpdated($event, 'dateRange')"
                    />
                    <input class="input-field suffix" placeholder="Select Start Date" [formControlName]="'startDate'" [readonly]="true">
                    <button (click)="openDatepicker($event, 0)" class="ngx-daterangepicker-action date-picker-btn"></button>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">End Date</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input class="input-field suffix" placeholder="Select End Date" [formControlName]="'endDate'" [readonly]="true">
                    <button (click)="openDatepicker($event, 0)" class="ngx-daterangepicker-action date-picker-btn"></button>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Default Date</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input type="text" class="input-field suffix"
                           ngxDaterangepickerMd
                           [closeOnAutoApply]="true"
                           [autoApply]="true"
                           [singleDatePicker]="true"
                           [style]="{'display': 'none'}"
                           (datesUpdated)="datesUpdated($event, 'defaultDate')"
                    />
                    <input class="input-field suffix" placeholder="Select Default Date" [formControlName]="'defaultDate'" [readonly]="true">
                    <button (click)="openDatepicker($event, 1)" class="ngx-daterangepicker-action date-picker-btn"></button>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>
